import { useState } from 'react';

import MakeChart from '#assets/svg/make_chart.svg';
import MakeSchedule from '#assets/svg/make_schedule.svg';
import { useNavigate } from 'react-router';
import { useUserInfo } from '#providers/UserInfo';
import ScheduleModal from 'src/refactor_components/main/modal/schedule-modal';

const Profile = () => {
  const navigate = useNavigate();
  const { userInfo } = useUserInfo();

  const [modalOpen, setModalOpen] = useState(false);

  const onClickByValue = (key: string) => {
    switch (key) {
      case 'charts':
        return setModalOpen(true);

      case 'schedule':
        return navigate('/manage');

      default:
        break;
    }
  };

  return (
    <div className="flex flex-col gap-[24.5px]">
      <div className="flex gap-[16px] items-center">
        <img
          src={userInfo?.profile[0]?.resizedLink}
          className="w-[54px] h-[54px] rounded-full bg-white"
        />
        <span className="font-normal text-[#C9C7D1]">
          안녕하세요,
          <br />
          <span className="text-[24px] text-[#EAE8ED] font-semibold">
            {userInfo?.name}{' '}
          </span>
          트레이너님!
        </span>
      </div>
      <div className="flex gap-[6px]">
        {LINKS.map(({ icon, label, key }) => {
          return (
            <button
              key={key}
              className="w-full border text-[14px] border-solid border-[#4D495A] text-[#C9C7D1] bg-[#2E2B36] rounded-[8px] py-[12px] px-[12px] flex gap-4 items-center justify-center"
              onClick={() => onClickByValue(key)}
            >
              <img src={icon} />
              <span>{label}</span>
            </button>
          );
        })}
      </div>
      {modalOpen && <ScheduleModal setModalOpen={setModalOpen} />}
    </div>
  );
};

const LINKS = [
  { key: 'schedule', label: '수업 일정 생성', icon: MakeSchedule },
  { key: 'charts', label: '운동 차트 작성', icon: MakeChart }
];

export default Profile;
